<template>
  <div class="contract-summary-document">
    Die Vertragszusammenfassung finden Sie <span class="link" @click="download">hier</span>.
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ContractSummaryDocument',
  computed: {
    ...mapGetters('orderProduct', [
      'contractDocumentUrl'
    ]
    )
  },
  methods: {
    download () {
      const baseUrl = this.$config.apiUrl
      if (this.contractDocumentUrl) {
        this.isAgreement = true
        window.open(
          `${baseUrl}${this.contractDocumentUrl}`
        )
      }
    }
  }
}
</script>
